// TableCard.js
import { memo, useContext, useMemo, useState } from "react";
import Style from "./style.module.css"
import Tooltip from "../../ui/tooltip";
import { GlobalContext } from "../../../context/Context";
import XCloseIcon from "../../icons/x-close";
import moment from "moment";

export function TableCard({ children, className, scrollClassName, ...props }) {
    return (
        <div className={`${Style.tableCard} ${className || ''}`} {...props}>
            <div className={`${Style.tableCard_scroll} ${scrollClassName || ""}`}>
                {children}
            </div>
        </div>
    );
}

// Table.js
export function Table({ children, className, ...props }) {
    return (
        <table className={`${Style.customtable} ${className || ''}`} {...props}>
            {children}
        </table>
    );
}

export function TableHead({ children, className, ...props }) {
    return (
        <thead className={`${Style.custom_thead} ${className || ''}`} {...props}>
            {children}

            <tr className="!bg-white">
                <th className="!p-[4px] !border-none !bg-transparent"></th>
            </tr>
        </thead>
    );
}

export function TableBody({ children, className, ...props }) {
    return (
        <tbody className={`${Style.custom_tbody} ${className || ''}`} {...props}>
            {children}
        </tbody>
    );
}

export function TableFooter({ children, className, ...props }) {
    return (
        <tfoot className={`${Style.custom_tfoot} ${className || ''}`} {...props}>
            <tr className="!bg-white">
                <th className="!p-[4px] !border-none !bg-transparent"></th>
            </tr>

            {children}
        </tfoot>
    );
}


export function TableRow({ children, className, ...props }) {
    return <tr {...props} className={className || ''}>{children}</tr>;
}

export function TableCell({ children, className, header = false, sticky = false, ...props }) {
    return header ? (
        <th {...props} className={`${className || ''} ${sticky ? Style.is_sticky : ''}`}>
            {children}
        </th>
    ) : (
        <td {...props} className={`${className || ''} ${sticky ? Style.is_sticky : ''}`}>
            {children}
        </td>
    );
}

export function TableHeaderWrap({ children, className, ...props }) {
    return (
        <div className={`${Style.tableHeading_wrap} ${className || ''}`} {...props}>
            {children}
        </div>
    );
}


export const TableSort = memo(({ field, sortFields = [], onSort, className, disabled = false, ...props }) => {
    const currentSort = sortFields.find(f => f.field === field)?.order;

    const TableSortNoneIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 12" fill="none">
            <path d="M16 5.25H0V6.75H16V5.25Z" fill="currentColor" />
            <path d="M16 0H0V1.5H16V0Z" fill="currentColor" />
            <path d="M16 10.5H0V12H16V10.5Z" fill="currentColor" />
        </svg>
    );

    const TableSortUpIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none">
            <path d="M16 5.33294C16 5.70162 15.6946 5.99964 15.3167 5.99964H6.43358C6.05639 5.99964 5.75027 5.70162 5.75027 5.33294C5.75027 4.96426 6.05639 4.66625 6.43358 4.66625H15.3167C15.6946 4.66625 16 4.96426 16 5.33294ZM13.2667 7.99971H6.43358C6.05639 7.99971 5.75027 8.29772 5.75027 8.6664C5.75027 9.03508 6.05639 9.33309 6.43358 9.33309H13.2667C13.6446 9.33309 13.9501 9.03508 13.9501 8.6664C13.9501 8.29772 13.6446 7.99971 13.2667 7.99971ZM11.2168 11.3332H6.43358C6.05639 11.3332 5.75027 11.6312 5.75027 11.9999C5.75027 12.3685 6.05639 12.6665 6.43358 12.6665H11.2168C11.5947 12.6665 11.9001 12.3685 11.9001 11.9999C11.9001 11.6312 11.5947 11.3332 11.2168 11.3332ZM9.16685 14.6666H6.43358C6.05639 14.6666 5.75027 14.9646 5.75027 15.3333C5.75027 15.702 6.05639 16 6.43358 16H9.16685C9.54404 16 9.85016 15.702 9.85016 15.3333C9.85016 14.9646 9.54404 14.6666 9.16685 14.6666ZM5.83295 2.19483L3.98253 0.388764C3.45023 -0.129255 2.58379 -0.129921 2.05012 0.388764L0.200382 2.19483C-0.0667941 2.45551 -0.0667941 2.87685 0.200382 3.13753C0.467559 3.39821 0.900097 3.39821 1.16659 3.13753L2.33369 1.99882V15.3333C2.33369 15.702 2.63982 16 3.01701 16C3.3942 16 3.70032 15.702 3.70032 15.3333V1.99882L4.86674 3.13753C4.99999 3.26754 5.17492 3.33287 5.34985 3.33287C5.52478 3.33287 5.6997 3.26754 5.83295 3.13753C6.10013 2.87685 6.10013 2.45551 5.83295 2.19483Z" fill="currentColor" />
        </svg>
    )

    const TableSortDownIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none">
            <path d="M15.3333 1.29412C15.702 1.29412 16 1.00488 16 0.647059C16 0.289236 15.702 0 15.3333 0H6.66667C6.29867 0 6.00001 0.289236 6.00001 0.647059C6.00001 1.00488 6.29867 1.29412 6.66667 1.29412H15.3333Z" fill="currentColor" />
            <path d="M6.66667 3.2353H13.3333C13.702 3.2353 14 3.52453 14 3.88235C14 4.24018 13.702 4.52941 13.3333 4.52941H6.66667C6.29867 4.52941 6.00001 4.24018 6.00001 3.88235C6.00001 3.52453 6.29867 3.2353 6.66667 3.2353Z" fill="currentColor" />
            <path d="M6.66667 6.47059H11.3333C11.702 6.47059 12 6.75982 12 7.11765C12 7.47547 11.702 7.76471 11.3333 7.76471H6.66667C6.29867 7.76471 6.00001 7.47547 6.00001 7.11765C6.00001 6.75982 6.29867 6.47059 6.66667 6.47059Z" fill="currentColor" />
            <path d="M6.66667 9.70588H9.33334C9.70134 9.70588 10 9.99512 10 10.3529C10 10.7108 9.70134 11 9.33334 11H6.66667C6.29867 11 6.00001 10.7108 6.00001 10.3529C6.00001 9.99512 6.29867 9.70588 6.66667 9.70588Z" fill="currentColor" />
            <path d="M0.199275 13.8052L2.03947 15.6112C2.56883 16.1293 3.43049 16.1299 3.96121 15.6112L5.80072 13.8052C6.06643 13.5445 6.06643 13.1231 5.80072 12.8625C5.53502 12.6018 5.10488 12.6018 4.83986 12.8625L3.6792 14.0012V0.666691C3.6792 0.298011 3.37477 0 2.99966 0C2.62455 0 2.32012 0.298011 2.32012 0.666691V14.0012L1.16015 12.8625C1.02763 12.7325 0.853673 12.6671 0.67971 12.6671C0.505748 12.6671 0.331786 12.7325 0.199275 12.8625C-0.0664251 13.1231 -0.0664251 13.5445 0.199275 13.8052Z" fill="currentColor" />
        </svg>
    )

    const sortClass = [
        Style.table_sort,
        disabled ? Style.disabledSort : '',
        currentSort === 'asc' ? Style.sortAsc : '',
        currentSort === 'desc' ? Style.sortDesc : '',
    ].join(' ');

    const icon =
        currentSort === 'asc' ? TableSortUpIcon :
            currentSort === 'desc' ? TableSortDownIcon :
                TableSortNoneIcon;

    const handleClick = () => {
        if (!disabled && typeof onSort === 'function') {
            onSort(field);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`${sortClass} ${className}`}
            disabled={disabled}
            {...props}
        >
            {icon}
        </button>
    );
});


export function TableMaxContect({
    children,
    className = "",
    textCount = 50,
    text,
    tooltipClassName = "",
    seeMoreClassName = "",
    ...props
}) {
    const content = String(text ?? children ?? "");
    const isTruncated = content.length > textCount;

    if (!isTruncated) {
        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{ __html: content }}
                {...props}
            />
        );
    }

    return (
        <div className={`${className} flex items-center`} {...props}>
            <div
                dangerouslySetInnerHTML={{
                    __html: content.slice(0, textCount) + "..."
                }}
            />

            <Tooltip
                content={<div dangerouslySetInnerHTML={{ __html: content }} />}
                position="left center"
                boxClassName={`${tooltipClassName} !max-w-[680px] !text-[14px]`}
            >
                <span className={`${seeMoreClassName} underline text-gray-500 ms-2`}>
                    See More
                </span>
            </Tooltip>
        </div>
    );

    // if (!isTruncated) {
    //     return <div className={className} {...props}>{content}</div>;
    // }

    // return (
    //     <div className={`${className} flex items-center`} {...props}>
    //         {`${content.slice(0, textCount)}...`}
    //         <Tooltip
    //             content={content}
    //             position="left center"
    //             boxClassName={`${tooltipClassName} !max-w-[680px] !text-[14px]`}
    //         >
    //             <span className={`${seeMoreClassName} underline text-gray-500 ms-2`}>
    //                 See More
    //             </span>
    //         </Tooltip>
    //     </div>
    // );
}

export function TableDepartmentTag({
    children,
    title,
    colorIndex,
    className = "",
    bg = null,
    fg = null,
    array = [],
    ...props
}) {
    const { state } = useContext(GlobalContext);

    const depColor = [
        { bg: "#EBE7FF", fg: "#401A81" },
        { bg: "#EEF8FF", fg: "#243F52" },
        { bg: "#E7FDF4", fg: "#1D4432" },
        { bg: "#F2D9E8", fg: "#542340" },
        { bg: "#FFFBE7", fg: "#603B1B" },
        { bg: "#FFF5EC", fg: "#4E351F" },
        { bg: "#ECF6DC", fg: "#334319" },
        { bg: "#EBF1FF", fg: "#1C305F" },
        { bg: "#EBF8FF", fg: "#173647" },
        { bg: "#EDD6E0", fg: "#550F2E" },
        { bg: "#EDEDED", fg: "#1E2E54" },
        { bg: "#FFF1EB", fg: "#582D1A" },
        { bg: "#E7FDFF", fg: "#204C55" },
        { bg: "#E4CCD7", fg: "#5E203C" },
        { bg: "#E0FAEC", fg: "#1D4E34" },
    ];

    const getColorIndex = (num) => ((num ?? 1) - 1) % depColor.length;

    const selectedColor = useMemo(() => {
        if (colorIndex !== undefined && colorIndex !== null) {
            return depColor[getColorIndex(colorIndex)];
        }

        const colorKey = title || (typeof children === "string" ? children : String(children));
        const index =
            array.length
                ? array.find((e) => e?.name === colorKey)?.id ??
                state?.getDropdowns?.departColorList?.[colorKey] ??
                1
                : state?.getDropdowns?.departColorList?.[colorKey] ?? 1;
        // console.log("object CHECK tile : ", title, index, state?.getDropdowns?.departColorList)
        return depColor[getColorIndex(index)];
    }, [colorIndex, state, title, children]);

    return (
        <div
            className={` px-[20px] py-[8px] rounded-2xl text-center text-[13px] font-medium text-black inline-flex ${className}`}
            style={{
                backgroundColor: bg || selectedColor.bg,
                color: fg || selectedColor.fg,
            }}
            {...props}
        >
            {title || children}
        </div>
    );
}

export function TableMaxTags({
    values = [],
    maxVisible = 2,
    className = "",
    waperClass = "",
    tagClass = "",
    tagStyle = {},
    moreClass = "",
    moreStyle = {},
    showLessClass = "",
    showLessStyle = {},
    ...props
}) {
    const [showAll, setShowAll] = useState(false);

    const visibleTags = showAll ? values : values.slice(0, maxVisible);
    const remainingCount = values.length - maxVisible;

    const defaultTagStyle = {
        backgroundColor: 'rgb(235, 231, 255)',
        color: 'rgb(64, 26, 129)',
        ...tagStyle,
    };

    const defaultMoreStyle = {
        backgroundColor: '#E0E0E0',
        color: 'rgb(64, 26, 129)',
        ...moreStyle,
    };

    return (
        <div className={`${className}`} {...props}>
            <div className={`flex gap-1 flex-wrap max-w-full ${waperClass}`}>
                {/* min-w-[200px] */}
                {visibleTags.map((item, index) => (
                    <div
                        key={`tag_${index}`}
                        className={`px-[12px] py-[5px] rounded-xl text-[12px] font-medium inline-flex ${tagClass}`}
                        style={defaultTagStyle}
                    >
                        {item.replace(/^(p_|e(_\d+)?_|q(_\d+)?_)/, '').replaceAll('_', ' ').trim().replace(/\b\w/g, c => c.toUpperCase())}
                    </div>
                ))}

                {!showAll && remainingCount > 0 && (
                    <div
                        onClick={() => setShowAll(true)}
                        className={`px-[10px] py-[5px] rounded-xl text-[12px] font-medium cursor-pointer inline-flex ${moreClass}`}
                        style={defaultMoreStyle}
                    >
                        +{remainingCount} more
                    </div>
                )}
            </div>

            {showAll && values.length > maxVisible && (
                <div
                    onClick={() => setShowAll(false)}
                    className={`mt-2 text-[12px] cursor-pointer ${showLessClass || "text-blue-600"}`}
                    style={showLessStyle}
                >
                    Show less
                </div>
            )}
        </div>
    );
}

export function TableFilterReturn({
    filterReturn = [],
    onChange = () => { },
}) {
    const removeFilter = (index) => {
        const updatedFilters = filterReturn.filter((_, i) => i !== index).filter(eachFilter => !eachFilter?.isCrossDisable);
        onChange(updatedFilters); // 🔥 return updated filters
    };

    const getLabel = (filter) =>
        filter?.label ||
        filter?.name?.replace("search_by_", "").replaceAll("_", " ");

    const renderValue = (filter) => {
        if (!filter.value) return "";

        // 1️⃣ Dropdown type: show label instead of raw value
        if (filter.type === "dropdown" && Array.isArray(filter.dropdown)) {
            console.log("Test", filter)
            if (Array.isArray(filter.value)) {
                return filter.value?.length > 3 ? `${filter.value?.slice(0, 3)
                    .map(
                        (val) =>
                            filter.dropdown.find((d) => d[filter.dropdownVal] == val)?.[
                            filter.dropdownKey
                            ] || val
                    )
                    .join(" , ")}, ${filter.value?.slice(3)?.length}+` : filter.value
                    .map(
                        (val) =>
                            filter.dropdown.find((d) => d[filter.dropdownVal] == val)?.[
                            filter.dropdownKey
                            ] || val
                    )
                    .join(" , ");
            } else {
                return (
                    filter.dropdown.find((d) => d[filter.dropdownVal] == filter.value)?.[
                    filter.dropdownKey
                    ] || filter.value
                );
            }
        }

        // 2️⃣ Normal string / array
        if (typeof filter.value === "string") return filter?.type == "date" ? moment(filter.value).format("DD MMM YYYY") : filter?.type == "month" ? moment(filter.value, "YYYY-MM").format("MMM YYYY") : filter.value;

        if (Array.isArray(filter.value)) {
            return filter?.type == "date" ? filter.value?.map((eachDate) => moment(eachDate).format("DD MMM YYYY")).join(" to ") : filter?.type == "month" ? filter.value?.map((eachMonth) => moment(eachMonth, "YYYY-MM").format("MMM YYYY")).join(" to ") : filter.value.join(" to ");
        }

        return "";
    };

    if (!filterReturn.length) return null;

    return (
        <div className={Style.filterContainer}>
            <p className={Style.searchText}>Search By</p>
            {filterReturn.map((eachFilter, i) => (
                <div className={Style.eachFilter} key={i}>
                    <p>
                        <span>{getLabel(eachFilter)} :</span>
                        <b>{(Array.isArray(eachFilter.value) && eachFilter.value?.length > 1) ? "are" : eachFilter?.selectedOpt}</b>
                        <em>{renderValue(eachFilter)}</em>
                    </p>

                    {!eachFilter?.isCrossDisable?
                        <span
                            className={Style.searchClosedBtn}
                            onClick={() => removeFilter(i)}
                        >
                            <div className={Style.icon}>
                                <XCloseIcon />
                            </div>
                        </span>
                        :
                        null
                    }
                </div>
            ))}
        </div>
    );
}